import PropTypes from 'prop-types'
import {Flex} from '@chakra-ui/react'

const SubsectionContainer = ({children, ...props}) => {
  return (
    <Flex
      p="md"
      direction="column"
      gap="md"
      bgColor="mld.neutral.200"
      borderRadius="base"
      {...props}
    >
      {children}
    </Flex>
  )
}

SubsectionContainer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SubsectionContainer
